import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import InformationSection from 'components/settings/personnel/InformationSection';

export default function InformationSectionWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <InformationSection {...wrappedProps} />
    </AppWrapper>
  );
}
